/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport } from '@typescript-kit/core';
import { Locale } from '@typescript-kit/core';

import * as texts from '../text/view-de.text.json';

export const viewDeLocale: Locale = {
  texts: getJsonExport(texts)
};
